import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { NameAndImage } from '../../NameAndImage';
import { nameAndImage } from '../../sharedSchemas';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const NameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const initialValues: FormValues = {
    name: '',
    imageType: 'major_purchase',
  };

  const handleSubmit = (values: FormValues) => {
    void navigate(`/add_purpose/major_purchase/${flowId}/target_details`);
  };

  return <NameAndImage handleSubmit={handleSubmit} initialValues={initialValues} />;
};
